const transactionTypes = {
    PURCHASE: 'credit',
    ROLLOVER: 'debit',
    SWITCH_INTRA_BANK: 'debit',
    SWITCH_INTER_BANK: 'debit',
    ROLLBACK: 'debit',
    FEE: 'debit',
    BONUS: 'credit',
    INTEREST_POSTING: 'credit',
    INTEREST_PAYOUT: 'debit',
    WITHDRAWAL: 'debit',
    ACH_RETURN: 'debit',
    ROLLOVER_NEW_DEPOSIT: 'credit',
    ROLLOVER_PREVIOUS_DEPOSIT: 'credit'
};
export function getTransactionCredit({ type, value }) {
    return transactionTypes[type] === 'credit' ? value : undefined;
}
export function getTransactionDebit({ type, value }) {
    return transactionTypes[type] === 'debit' ? value : undefined;
}
const transactionNames = {
    PURCHASE: (productOffer, depositStatus, isCashAccount) => isCashAccount ? 'Deposits and Transfers in' : `Deposit to ${productOffer.name}`,
    ROLLOVER: () => 'CD Matured and Rolled Over',
    SWITCH_INTRA_BANK: () => 'SWITCH_INTRA_BANK',
    SWITCH_INTER_BANK: () => 'SWITCH_INTER_BANK',
    ROLLBACK: (productOffer, depositStatus) => ['HIGH_YIELD_CD', 'NO_PENALTY_CD'].includes(productOffer.type)
        ? ['PAYOUT_IN_PROGRESS', 'MATURED'].includes(depositStatus)
            ? `Withdrawal from ${productOffer.name}`
            : ['AWAITING_CANCELLATION', 'CLOSED'].includes(depositStatus)
                ? 'CD Cancelled and Paid-Out'
                : ''
        : `Withdrawal from ${productOffer.name}`,
    FEE: () => 'Early withdrawal fee',
    BONUS: () => 'BONUS',
    INTEREST_POSTING: () => 'Interest Paid',
    INTEREST_PAYOUT: () => 'INTEREST_PAYOUT',
    WITHDRAWAL: (productOffer, depositStatus, isCashAccount) => isCashAccount ? 'Withdrawals and Transfer Outs' : `Withdrawal from ${productOffer.name}`,
    ACH_RETURN: () => 'Funds returned through ACH Return',
    ROLLOVER_PREVIOUS_DEPOSIT: () => 'CD Renewed to a new account',
    ROLLOVER_NEW_DEPOSIT: () => 'Renewed CD Deposit'
};
export function getTransactionName({ productOffer, type, depositStatus, isCashAccount }) {
    return transactionNames[type](productOffer, depositStatus, isCashAccount);
}
